import * as SjtActions from './../actions/stocks.actions';
import { IStocks } from './../../interfaces/models';

export type Action = SjtActions.All;

// Reducer function
export function stocksReducer(data: IStocks[] = [], action: Action) {
  switch (action.type) {
    case SjtActions.SET: {
      return action.data;
    }
    case SjtActions.EDIT: {
      data.forEach((c: IStocks, index) => {
        if (c.id === action.data.id) {
          data[index] = action.data;
        }
      });

      return [...data];
    }
    case SjtActions.ADD: {
      return [action.data, ...data];
    }
    case SjtActions.DELETE: {
      const newData = data.filter((c: IStocks) => {
        return c.id !== action.id;
      });
      return newData;
    }
    case SjtActions.OPEN_MODAL: {
      return true;
    }
    case SjtActions.CLOSE_MODAL: {
      return false;
    }
    default: {
      return data;
    }
  }
}
